
import React from 'react';

const WatchUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M21 6.52V2c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v4.52A9.01 9.01 0 007 14a9.01 9.01 0 004 7.48V26c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-4.52c2.41-1.62 4-4.36 4-7.48a9.01 9.01 0 00-4-7.48zM13 2h6v3.53c-.94-.34-1.95-.53-3-.53s-2.06.19-3 .53V2zm6 24h-6v-3.53c.94.34 1.95.53 3 .53s2.06-.19 3-.53V26zm-3-5c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z'
			></path>
			<path
				fill='#2d2d2d'
				d='M17 9h-2v5c0 .2.06.39.17.55l2 3 1.66-1.11L17 13.7V9zM22 30H10v2h12v-2z'
			></path>
		</svg>
	);
};

export default WatchUnderline;
